import { SessionStorage } from "./sessionStorage";

const PARTNER_URL_SESSION_KEY = "partner_back_url";

const partnerUrlSessionStorage = new SessionStorage(PARTNER_URL_SESSION_KEY);

export const savePartnerUrl = (url: string): void => {
  if (typeof sessionStorage === "undefined") {
    return;
  }
  partnerUrlSessionStorage.saveDataToSessionStorage(url);
};

export const getPartnerUrl = (): string | null => {
  if (typeof sessionStorage === "undefined") {
    return null;
  }
  return partnerUrlSessionStorage.loadDataFromSessionStorage<string>() ?? null;
};

export const removePartnerUrl = (): void => {
  if (typeof sessionStorage === "undefined") {
    return;
  }
  partnerUrlSessionStorage.removeDataFromSessionStorage();
};
